<script lang="ts" setup>
  import { computed, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { useNotification } from '@kyvg/vue3-notification';
  import { getSession } from '@/indexedDB';
  import PdfCalculationCard from '@/components/pdfViews/PdfCalculationCard.vue';
  import { carData } from '@/types';

  interface additioanlMenu {
    label: string;
    icon: string;
    isRoute?: boolean;
    routeName?: string;
    action: (value: string) => void;
  }

  const router = useRouter();
  const { notify } = useNotification();

  const reportRef = ref(null);
  const data = ref<carData | null>(null);
  const showPDF = async () => {
    data.value = await getSession('car');
    await reportRef.value?.generatePDF();
  };

  const items = computed(() => [
    {
      icon: 'pi pi-calculator',
      command: () => {
        router.push('/calculator');
      },
    },
    {
      icon: 'pi pi-chart-bar',
      command: () => {
        router.push('/analytics');
      },
    },
    {
      icon: 'pi pi-file-pdf',
      command: async () => {
        await showPDF();
      },
    },
    {
      hidden: data.value === null,
      icon: 'pi pi-ellipsis-v',
      items: [
        {
          label: 'Port USA',
          command: () => {
            router.push('/usa-port');
          },
        },
        {
          label: 'Port Klaipeda',
          command: () => {
            router.push('/klaipeda-port');
          },
        },
        {
          label: 'Carfax',
          command: () => {
            router.push('/car-fax');
          },
        },
      ],
    },
    {
      hidden: data.value !== null,
      icon: 'pi pi-download',
      command: async () => {
        await showPDF();
      },
    },
    {
      hidden: data.value !== null,
      icon: 'pi pi pi-times',
      command: async () => {
        data.value = null;
      },
    },
  ]);
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const isAndroid = computed(() => /android/i.test(userAgent));
  const isIOS = computed(
    () => /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
</script>

<template>
  <div class="fixed bottom-0 left-0 w-full bg-gray-100 border-t">
    <div
      class="card"
      :class="{
        'mb-5': isIOS,
      }"
    >
      <Menubar
        :class="{
          'px-2': isIOS,
        }"
        :model="items"
        breakpoint=""
      >
        <template #item="{ item, props, hasSubmenu }">
          <router-link
            v-if="item.route && (item?.hidden ?? true)"
            v-slot="{ href, navigate }"
            :to="item.route"
            custom
          >
            <a :href="href" v-bind="props.action" @click="navigate">
              <i style="font-size: 1.5rem" :class="item.icon" />
              <span v-if="item.label">{{ item.label }}</span>
            </a>
          </router-link>
          <a
            v-else-if="item?.hidden ?? true"
            :href="item.url"
            :target="item.target"
            v-bind="props.action"
          >
            <i style="font-size: 1.5rem" :class="item.icon" />
            <span v-if="item.label">{{ item.label }}</span>
            <span v-if="hasSubmenu" class="pi pi-fw pi-angle-up" />
          </a>
        </template>
      </Menubar>
    </div>
    <pdf-calculation-card
      @close="data = null"
      v-if="data"
      ref="reportRef"
      :info="data?.info"
      :shipping="data?.shipping"
    ></pdf-calculation-card>
  </div>
</template>

<style scoped></style>
